<div class="success-wrapper">
  <div class="success animated zoomIn" (clickOutside)="close.emit()" [clickOutsideEvents]="'click'" appClickOutsideFix >
    <div class="success-header">
      <h3>{{ title }}</h3>
      <div (click)="close.emit()" class="close"></div>
    </div>
    <div class="success-body">
      <div class="success-info">
        <!-- Absent only when a save wrote nothing and the failure line stands alone (HUBX-8478). -->
        <p *ngIf="sucessMsg" [class.success-done]="successIcon">
          <!-- The row's "Saved." check (HUBX-8498), only where the caller asks for it. -->
          <svg *ngIf="successIcon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="#2E9E6B"
            stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" stroke-width="2"/><path d="m7.5 12.5 3 3 6-6.5"/>
          </svg>
          <span>{{sucessMsg}}</span>
        </p>
        <!-- What a multi-row save did not write (HUBX-8478): the red exclamation, as on the
             rows, and no tinted box (HUBX-8498). -->
        <p class="success-failed" *ngIf="failedMsg">
          <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="#C0392B"
            stroke-width="2.2" stroke-linecap="round">
            <circle cx="12" cy="12" r="10" stroke-width="2"/><path d="M12 7v6"/><path d="M12 17h.01" stroke-width="2.8"/>
          </svg>
          <span>{{failedMsg}}</span>
        </p>
        <!-- Optional advisory about the write that just succeeded (HUBX-8429's
             category notice is the first). Absent for every caller that passes none. -->
        <p class="success-note" *ngIf="note">
          {{note}}
        </p>
      </div>
      <div class="success-ctrl">
        <!-- Optional (HUBX-8498): the listing's way to the rows a save did not write. -->
        <a role="button" class="btn success-action" *ngIf="actionLabel" (click)="action.emit()">
          {{actionLabel}}
        </a>
        <a role="button" class="btn" (click)="close.emit()">
          Continue
        </a>
      </div>

    </div>
  </div>
</div>
